exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gm-style p[data-v-3cfe1645] {\n  color: #2a3e63;\n}", ""]);

// exports
